import React, {useEffect} from "react";
import NavXCSI from "../layout/respnsivenavigation/nav-xsci";
import FooterXsci from "../layout/footer/footer-xsci";
import {useTranslation} from "react-i18next";
import HeroSectionV2 from "./herobanner/v2/hero-section-v2";
import WhoWeAre from "./who-we-are/whoWeAre";
import OurStory from "./our-story/ourStory";
import BusinessFirstApproach from "./process/businessFirstApproach";
import SystemDesign from "./engineering/systemDesign";
import ParallaxSection from "../home/parallax-cta/parallax-section";

const About = () => {


    const { t, i18n } = useTranslation(); // Use the translation hook

    const currentLanguage = i18n.language; // Get current language

    const pageTitle = "About Us - XSCI - Kanata";
    const metaDescriptionContent = "Learn more about XSCI Web Solutions," +
        " a team of experienced web developers dedicated to creating stunning, functional websites, web applications and software tailored to your business needs."

    useEffect(() => {
        document.title = pageTitle;

        // Set the meta description
        let metaDescription = document.querySelector("meta[name='description']") as HTMLMetaElement;

        // The content you're trying to use for the meta description
        const descriptionContent = metaDescriptionContent;

        if (metaDescription) {
            metaDescription.setAttribute("content", descriptionContent); // Correctly set the content
        } else {
            metaDescription = document.createElement("meta") as HTMLMetaElement;
            metaDescription.name = "description";
            metaDescription.content = descriptionContent;
            document.head.appendChild(metaDescription);
        }
    }, []);
    return (
        <>
            <NavXCSI/>
            <HeroSectionV2
                backgroundImage={"/images/about/aboutHero3.jpg"}
                title={"Custom Web Solutions Fueling Business Growth"}
                description={"XSCI builds robust web apps and platforms engineered to support your day to day operations across all industries."}
                highlight={""}
                />
            <WhoWeAre/>
            <OurStory/>
            <BusinessFirstApproach/>
            <SystemDesign/>
            <ParallaxSection
                message={"Have a system or idea you’re thinking through?"}
                subMessage={"We can help clarify the path forward."}
                buttonText={"Start a Conversation"}
            />
            <FooterXsci/>
        </>
    );
};

export default About;
